import {PdsWidget} from './pds-widget';
import {ClassPickerClass} from './interfaces/class-picker-class';
import {ClassPickerNavItem} from './interfaces/class-picker-nav-item';
import {pdsUtils} from './pds-utils';
import {ClassGroupRI} from 'common-utils/rest-interfaces';

export class PdsClassBlock extends PdsWidget {
  is = 'pds-class-block';

  section: ClassPickerClass;

  primaryText: string;

  primarySubText: string;

  secondaryText: string;

  links: Array<ClassPickerNavItem>;

  attendanceStatusLink: ClassPickerNavItem;

  showLinks = false;

  hasMultipleSchools: boolean;

  attached(): void {
    super.attached();
    let classPickerElement = document.querySelector('pds-class-picker');
    if (classPickerElement != null) {
      // add event listeners so we can close the options menus
      classPickerElement.addEventListener('pdsCloseOptions', (event) => {
        if ((<any>this) !== event.srcElement) {
          this.showLinks = false;
        }
      });
      classPickerElement.addEventListener('click', (event) => {
        this.showLinks = false;
      });
    }
  }

  classChange(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    let target = <HTMLElement & {dataSection: ClassPickerClass}>event.target;
    if (!this.pds.utils.is(target, 'a')) {
      target = <HTMLElement & {dataSection: ClassPickerClass}>this.pds.utils.getClosest(target, 'a');
    }
    let newClass: ClassPickerClass = target.dataSection;
    this.fire('pdsClassChange', newClass);
  }

  clickOptions(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.showLinks = !this.showLinks;
    if (this.showLinks) {
      this.fire('pdsCloseOptions', null);
      // fire a event in firefox will reset value of this.showLinks
      this.showLinks = true;
    }
  }

  clickOptionsLink(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    let target = <HTMLElement & {dataLink: ClassPickerNavItem, dataSection: ClassPickerClass}>event.target;
    if (!this.pds.utils.is(event.target, 'a')) {
      target = <HTMLElement & {dataLink: ClassPickerNavItem, dataSection: ClassPickerClass}>this.pds.utils.getClosest(target, 'a');
    }

    let link: ClassPickerNavItem = target.dataLink;
    let newClass: ClassPickerClass = target.dataSection;

    // set the new class on the context in case the app needs it
    link.section = newClass;

    if (link.linkClicked != null) {
       link.linkClicked(link, event);
    } else {
      throw 'No onUserClick function found';
    }

    this.fire('pdsCloseClassPicker', null);

    this.showLinks = false;
  }

  getAttendanceStatusIconName(status: string): string {
    if (status == null) {
      return '';
    }
    switch (status.toUpperCase()) {
      case 'NA':
        return 'attendance-f';
      case 'GREEN':
        return 'checkmark-circle-f';
      case 'YELLOW':
        return 'attendance-f';
      case 'RED':
        return 'attendance-f';
      default:
        return '';
    }
  }

  getSectionColorClass(sectionOrGroup: any): string {
    return pdsUtils.getSectionColorForClass(sectionOrGroup);
  }

  getLinkId(sectionOrGroup: ClassPickerClass | ClassGroupRI): string {
    if (sectionOrGroup == null) {
      return 'no-section-error';
    }
    if ((<ClassPickerClass>sectionOrGroup).uid != null) {
      return (<ClassPickerClass>sectionOrGroup).uid;
    } else if ((<ClassGroupRI>sectionOrGroup).groupName != null) {
      return (<ClassGroupRI>sectionOrGroup).groupName.replace(/\s+/g, '-');
    } else {
      throw 'ClassPickerClass needs to either have a group name or a uid.';
    }
  }

  getSchoolAbbreviation(section: ClassPickerClass): string {
    let schoolAbbreviation = '';
    if (section.schoolAbbreviation) {
      schoolAbbreviation = section.schoolAbbreviation.length <= 8 ? section.schoolAbbreviation : section.schoolAbbreviation.slice(0, 8);
    } else {
      schoolAbbreviation = section.schoolName.length <= 8 ? section.schoolName : section.schoolName.slice(0, 8);
    }
    return schoolAbbreviation;
  }
}
